// Live flash sales (GET /promotions/flash-sales/active, API_CONTRACT §2c),
// shared by the home hero (main bundle) and the lazy flash-sale band.

/** A monotonic clock (not the device's wall clock) for countdowns. */
export const now = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now());

/** Public sales → [{...sale, deadline}] (deadline on the `now()` clock). */
export const withDeadlines = (data, at = now()) => {
  const list = Array.isArray(data?.flash_sales) ? data.flash_sales : [];
  return list
    .filter((s) => s && s.id && Array.isArray(s.products) && s.products.length > 0)
    .map((s) => ({ ...s, deadline: at + Math.max(0, Number(s.time_remaining) || 0) * 1000 }))
    .filter((s) => s.deadline > at);
};
